import React from "react";
import NavBar from "../components/Home/NavBar";
import { Link } from "react-router-dom";
import form2 from "../assets/forms/form2.png";
import form1 from "../assets/forms/form2.png";

const Renovaciones = () => {
  return (
    <div>
      <NavBar />
      <div className="w-screen flex flex-col sm:flex-row items-center justify-center p-12 sm:pt-28 gap-12 sm:gap-52">
        <div className="border border-slate-100 w-80 h-96 rounded-xl shadow-xl p-4 bg-white">
          <img src={form2} alt="img not found" className="" />
          <div className="flex flex-col items-center justify-center gap-3 p-4">
            <h1 className="font-bold">Renovación DDJJ</h1>
            <p className="text-xs">
              Solicitud de Inscripción al Registro Nacional de Pacientes en
              Tratamiento con Cannabis (REPROCANN)
            </p>
            <Link to="/renovacionddjj">
              <button className="w-full p-2 px-4 rounded-xl bg-background_home text-white">
                Completar
              </button>
            </Link>
          </div>
        </div>

        <div className="border border-slate-100 flex flex-col w-80 h-96 rounded-xl shadow-xl p-4 bg-white">
          <img src={form1} alt="img not found" className="" />
          <div className="flex flex-col items-center justify-center gap-6 p-4">
            <h1 className="font-bold">Renovación Consentimiento</h1>
            <p className="text-xs">Consentimiento Informado Bilateral</p>
            <Link to="/renovacionConsentimiento">
              <button className="w-full p-2 px-4 rounded-xl bg-background_home text-white">
                Completar
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Renovaciones;
